const options = {
  5: "bg-teal-50/5",
  10: "bg-teal-50/10",
  25: "bg-teal-50/25",
  50: "bg-teal-50/50",
  75: "bg-teal-50/75",
  90: "bg-teal-50/90",
  100: "bg-teal-50",
};

const from = {
  5: "from-teal-50/5",
  10: "from-teal-50/10",
  25: "from-teal-50/25",
  50: "from-teal-50/50",
  75: "from-teal-50/75",
  90: "from-teal-50/90",
  100: "from-teal-50",
};

export default function getBackgroundTeal50(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
